import "./scss/global.scss";
import "swiper/css";
import { createApp } from "vue";
import { useBreakpoints } from "@vueuse/core";
import { register } from "swiper/element/bundle";
import { FadeTransition } from "@bam/transitions";
import { OnClickOutside } from "@vueuse/components";
import { initStageBrandMorph } from "./modules/stage-brand-morph";
import { initBackToTop } from "./modules/back-to-top";
import { initCardGridSlider } from "./modules/card-grid-slider";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept();
}

const app = createApp({
    data: () => {
        return {
            // globalSwiperModules: [Pagination, Parallax],
        };
    },

    mounted() {
        register();
    },
});

// Die Swiper-Elemente stehen im server-gerenderten HTML und laufen deshalb durch
// den Laufzeit-Compiler, nicht durch den aus vite.config.js — dessen
// isCustomElement gilt nur für .vue-Dateien. Ohne diese Zeile sucht Vue nach
// einer Komponente dieses Namens und meldet sie als fehlend.
app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith("swiper");

// Vue mountet auf #app, und das umschliesst Header, Content und Footer. Weil
// das server-gerenderte HTML als In-DOM-Template compiliert wird, verwirft Vue
// bei einem Renderfehler die GANZE Seite — auch das Twig-Markup, das in Ordnung
// war. Der Handler verhindert das nicht, macht die Ursache aber sichtbar statt
// sie als kryptischen Stacktrace zu hinterlassen.
app.config.errorHandler = (err, instance, info) => {
    console.error(`[vue] ${info}:`, err, instance);
};

const bps = JSON.parse(
    getComputedStyle(document.body).getPropertyValue("--breakpoints")
);
const breakpoints = useBreakpoints(bps);
app.config.globalProperties.$breakpoints = breakpoints;

const components = import.meta.glob("./components/**/*.vue", { eager: true });
Object.entries(components).forEach(([path, definition]) => {
    const componentName = path
        .split("/")
        .pop()
        .replace(/\.\w+$/, "");
    app.component(componentName, definition.default);
});

// expand-transition kommt aus components/ExpandTransition.vue (über das Glob
// oben registriert). Die Variante aus @bam/transitions läuft auf --bam-Tokens,
// die dieses Projekt nicht hat, und würde ohne Dauer animieren.
app.component("fade-transition", FadeTransition);
app.component("on-click-outside", OnClickOutside);

app.mount("#app");

// Erst nach dem Mount: Vue compiliert das server-gerenderte HTML in #app neu,
// vorher gesetzte Klassen und Elementreferenzen wären verloren.
initStageBrandMorph();
initBackToTop();
// Nach register() aus mounted(): vorher gibt es an <swiper-container> kein .swiper.
initCardGridSlider();
